<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <FITAlert ref="alert" :alertContent="$t('auth.forgetPassword.success')" :alertSec="3" :dismissible="true"></FITAlert>
                <h1>{{ $t("auth.forgetPassword.forgetPassword") }}</h1>
                <p class="text-muted">{{ $t("auth.forgetPassword.forgetPasswordSubtitle") }}</p>
                <b-input-group class="my-4">
                  <b-input-group-prepend>
                    <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                  </b-input-group-prepend>
                  <input type="text" v-model="form.userEmail" class="form-control" :placeholder="$t('auth.forgetPassword.username')" required>
                </b-input-group>
                <b-row>
                  <b-col cols="6">
                    <b-button variant="primary" class="px-4" @click="forgetPassword">{{ $t("auth.forgetPassword.forgetPassword") }}</b-button>
                  </b-col>
                  <b-col cols="6" class="text-right">
                    <b-button variant="link" class="px-0" @click="backToLogin">{{ $t("auth.forgetPassword.backToLogin") }}</b-button>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import Cookies from 'js-cookie'
import Vue from 'vue'
import {
  FITAlert
} from '@/components'

export default {
  name: 'Login',
  components: {
    FITAlert
  },
  data() {
    return {
      form: {
        userEmail: ''
      }
    }
  },
  methods: {
    backToLogin() {
      this.$router.replace('/login');
    },

    forgetPassword() {
      this.$store.dispatch('Auth/forgetPassword', this.form)
        .then((json) => {
          this.$refs.alert.showAlert();
          Vue.set(this.form, 'userEmail', '');
        })
        .catch((err) => {
          console.debug(err);
        });
    }
  },
  created() {
    if (Cookies.get('token')) {
      this.$router.replace('/');
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/Auth/components/ForgetPassword.vue